var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16.933 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.7625 14.03h-.21647c-1.7751 0-3.1557-.59341-4.1418-1.7804-.98615-1.1869-1.4792-2.8393-1.4792-4.9571 0-2.112.49067-3.7673 1.472-4.9659.98614-1.1985 2.3427-1.7978 4.0697-1.7978 1.7462 0 3.1051.59347 4.0769 1.7804.97651 1.1869 1.4648 2.848 1.4648 4.9833-1e-5 1.4662-.25978 2.7287-.7793 3.7877-.51473 1.0589-1.2579 1.856-2.2296 2.3913l2.1719 2.9324h-2.6482l-1.7606-2.3738m-.29584-11.066c-.84665 0-1.5033.37817-1.9699 1.1346-.46662.75634-.69993 1.8211-.69992 3.1942-3e-6 1.3964.22849 2.4669.68549 3.2116.45699.7389 1.1184 1.1084 1.9843 1.1084.85144 0 1.5105-.3782 1.9771-1.1345.46661-.75639.69992-1.8182.69992-3.1855-8e-6-1.3731-.23332-2.4378-.69992-3.1942-.46662-.75639-1.1257-1.1346-1.9771-1.1346",
    fill: "#f00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/q.1bca9fce4f6010d85e5236fa2a747e29.svg";
export { ForwardRef as ReactComponent };